// extracted by mini-css-extract-plugin
export default {"temp":"WeatherWidget_temp__nc0y+"};